import { warnWithTrace } from '../helpers/logger';
import { get } from '../helpers/get';
import { createCSSVarName } from './create-css-var-name';
import { designTokens } from './example-design-tokens';
export const isFluidDesignTokenValue = (value) => {
    return Boolean(typeof value !== 'undefined' &&
        value.min &&
        value.max);
};
export function getDesignTokenValue(propertyPath = '', tokensOverride) {
    if (!propertyPath) {
        warnWithTrace(`Design token value could not be found: ${propertyPath}`);
        return undefined;
    }
    const designTokenValue = get(tokensOverride || designTokens, propertyPath);
    // propertyPath is probably already resolved, comes from the tokens package...
    if (!designTokenValue) {
        return propertyPath;
    }
    // array values, return css var instead
    // the assumption is that every array is a dynamic designToken
    if (Array.isArray(designTokenValue)) {
        return `var(${createCSSVarName(propertyPath)})`;
    }
    // fluid tokens
    if (isFluidDesignTokenValue(designTokenValue)) {
        return `var(${createCSSVarName(propertyPath)})`;
    }
    return designTokenValue;
}
